import scrollIntoView from "scroll-into-view";
import { messages } from "./constants";

export const cleanAndFormatDecimalNumber = (number) => {
    let escapeRe = new RegExp(/([ -,.*+?^=!:$(){}|[\]\/\\])/g);
    let letters = new RegExp(/([a-zA-Z])/g);
    let zero = /^0/;
    let numbers = /\d/;
    number = number.replace(escapeRe, '').replace(letters, '').replace(zero,'');

    let integers = number.slice(0,-2);
    let decimals = number.slice(-2);

    if(numbers.test(number)){
        integers = (integers) ? integers : '0';
        return (integers + '.' + decimals);
    }
    return '';
};

export const cleanAndFormatIntegerNumber = (number) => {
    let escapeRe = new RegExp(/([ -,.*+?^=!:$(){}|[\]\/\\])/g);
    let letters = new RegExp(/([a-zA-Z])/g);
    let zero = /^0/;
    let numbers = /\d/;
    number = number.replace(escapeRe, '').replace(letters, '').replace(zero,'');

    if(numbers.test(number)){
        return (number);
    }
    return '';
};

export const removeAllSpecialCharacters = (value) => {
    let escapeRe = new RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<> \{\}\[\]\\\/]/gi);
    value = value.replace(escapeRe, '');
    return (value);
};

export const validatePlateBrazil = (plate) => {
    plate = removeAllSpecialCharacters(plate).toUpperCase();
    let plateIsValid = false;
    let letters = /^[a-zA-Z]+$/;
    let numbers = /^\d+$/;

    if (plate.length === 7) {
        let firstSection = plate.slice(0,3);
        let secondSection = plate.slice(3,7);
        if (letters.test(firstSection) && numbers.test(secondSection)) {
            plateIsValid = true;
        }
    }
    return (plateIsValid)
};

export const validatePlateArgentina = (plate) => {
    plate = removeAllSpecialCharacters(plate).toUpperCase();
    let plateIsValid = false;
    let letters = /^[a-zA-Z]+$/;
    let numbers = /^\d+$/;

    if (plate.length === 7) {
        let firstSection = plate.slice(0,2);
        let secondSection = plate.slice(2,5);
        let thirdSection = plate.slice(5,7);
        if (letters.test(firstSection) && numbers.test(secondSection) && letters.test(thirdSection)) {
            plateIsValid = true;
        }
    }
    return (plateIsValid)
};

export const scrollToTop = () =>{
    window.scrollTo(0, 0);
};

export const parseToKeyValueToResponse = (data,key, value)=>{

    let ret = [];
    data.map((item)=>{
        ret.push({value:item[key], label: item[value]})
    });
    return ret;
};
export const removeSpecialCaracters=(str)=>{
    return str.replace(/[^a-z0-9]/gi,'');
};

export const scrollToBottom = (id_component)=>{
    if(document.getElementById(id_component)){
        scrollIntoView(document.getElementById(id_component));
    }
};

export const formatShortUserName = (name) =>{
    if(name){
        let arr = name.split(' ');
        return `${arr[0]} ${arr[arr.length-1]}`;
    }

    return name;
};

export const promiseTimeout = function(ms, promise, loadingOff) {
    let timeout = new Promise((resolve, reject) => {
        let id = setTimeout(() => {
            clearTimeout(id);
            if (loadingOff) {
                loadingOff();
            }
            reject(messages.timeOutError);
        }, ms);
    });

    return Promise.race([
        promise,
        timeout
    ]);
};


// WEBPACK FOOTER //
// ./src/util/tools.js